// Enum to store the different custom Datadog user actions we
// want to track.
export enum DDAction {
  EXPORT_ALLOCATIONS_REPORT = 'Export allocations report',
  EXPORT_DISTRITBUTIONS_REPORT = 'Export distributions report',
  EXPORT_DISTRIBUTIONS_ZIP = 'Export distributions ZIP',
}
